import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { coerceBoolean } from "@obg/ngx.global.evo";

import { PrimaryToolbarContent } from "./primary-toolbar.model";

@Component({
	selector: "obg-m-primary-toolbar",
	templateUrl: "./primary-toolbar.component.html",
	styleUrls: ["./primary-toolbar.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class PrimaryToolbarComponent {
	@HostBinding("class.obg-m-primary-toolbar") hostCssClass = true;

	@Input() content: PrimaryToolbarContent | undefined;

	@Input()
	@coerceBoolean()
	hideBackButton = false;

	@Input()
	@coerceBoolean()
	disableHeaderTag = false;

	@Output() backButtonClick = new EventEmitter<MouseEvent>();
	@Output() rightContentClick = new EventEmitter<MouseEvent>();
}
